export const base64encode = (blob: Blob): Promise<string> => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();

        reader.onload = event => {
            const dataUrl = event.target?.result as string;
            if (dataUrl) {
                resolve(dataUrl);
            }
            reject();
        };

        reader.readAsDataURL(blob);
    });
};
